//array to object json
const arrayToObj = (inputMap, recipient, idRemetente) => {
  let obj = {};
  inputMap.forEach(value => {
    if (
      value.usuario.toLowerCase() !== recipient.toLowerCase() &&
      value.id !== idRemetente
    )
      obj[value.usuario] = value.usuario.toUpperCase().replace(".", " ");
  });
  return obj;
};

export default arrayToObj;
